import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import TextWidget from "../../Widgets/TextWidget/TextWidgetClass";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageProperties,
  defaultPageInitialContent,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("EventPage", {
  title: "Event Page",
  thumbnailForContent: (obj) => obj.get("image"),
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "shortDescription",
      "locationStreet",
      "locationName",
      "locationDescription",
      "locationRegion",
      "locationUrl",
      "description",
      "add",
      "showInOverviewUntil",
      "allDay",
      "organizerName",
      "organizerUrl",
    ],
    "EventPage"
  ),
  properties: [
    "title",
    "shortTitle",
    "image",
    "description",
    "shortDescription",
    "hideInNavigation",
    "category",
  ],
  propertiesGroups: [
    {
      title: "Date and time",
      properties: ["date", "endDate", "allDay", "showInOverviewUntil"],
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
    {
      title: "Structured Data (Schema.org)",
      properties: [
        "organizerName",
        "organizerUrl",
        "locationName",
        "locationDescription",
        "locationRegion",
        "locationRoom",
        "locationStreet",
        "locationCity",
        "locationPostalCode",
        "locationCountry",
        "locationUrl",
        "postOfficeBoxNumber",
      ],
    },
  ],
  initialContent: {
    ...defaultPageInitialContent,
    body: [new TextWidget({ text: "Lorem Ipsum" })],
    title: "New Event",
    locationName: '<a href="/">Hochschule Heilbronn</a>',
    locationRoom: "Raum ",
    ...metadataInitialContent,
    organizerName: "Hochschule Heilbronn (HHN)",
    organizerUrl: "https://www.hs-heilbronn.de/",
  },
  initialize: (obj) => {
    const fromDate = new Date();
    const untilDate = new Date();
    untilDate.setDate(untilDate.getDate() + 1);
    obj.update({ date: fromDate, endDate: untilDate });
  },
  validations: [
    [
      "date",
      (date, { obj }) => {
        const fromDate = date;
        const untilDate = obj.get("endDate");
        if (fromDate && untilDate) {
          if (fromDate > untilDate) {
            return {
              message: "Start date should be before end date",
              severity: "error",
            };
          }
        }
        return null;
      },
    ],
    [
      "date",
      (date, { obj }) => {
        const maxDifference = 366;
        const fromDate = date;
        const untilDate = obj.get("endDate");
        if (fromDate && untilDate) {
          const diffTime = Math.abs(untilDate - fromDate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays > maxDifference) {
            return {
              message: `Difference between start and end date is larger then ${maxDifference} days`,
              severity: "warning",
            };
          }
        }
        return null;
      },
    ],
    [
      "date",
      (date) => {
        if (!date) {
          return {
            message: "An event object must have a date specified",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "endDate",
      (date) => {
        if (!date) {
          return {
            message: "An event object must have a end date specified",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "title",
      (title) => {
        if (!title) {
          return {
            message: "is required",
            severity: "error",
          };
        }
        return null;
      },
    ],
    [
      "title",
      (title) => {
        if (title === "" || title === "New Event") {
          return "Title can not be empty or set to its default value. Set a proper Title for this Page";
        }
        return null;
      },
    ],
    [
      "shortTitle",
      (shortTitle) => {
        if (shortTitle && shortTitle.length > 55) {
          return {
            message: "Short title should not exceed 55 characters.",
            severity: "warning",
          };
        }
        return null;
      },
    ],
    [
      "description",
      (description) => {
        if (description === "" || description === "<p></p>") {
          return "Description can not be empty, Set a propper description for this page.";
        }
        return null;
      },
    ],
    [
      "shortDescription",
      (shortDescription) => {
        if (shortDescription === "") {
          return "Short description can not be empty. Set a propper description for this page.";
        }
      },
    ],
    [
      (obj) => {
        if (!obj.path) {
          return "Path can not be empty. This Page is on root level and not in the Navigation structure. Move or delete this Object.";
        }
        return null;
      },
    ],
    [
      (obj) => {
        const hasSchema = obj
          .widgets()
          .some((w) => w.objClass() === "SchemaWidget");
        if (!hasSchema) {
          return {
            message:
              "No SchemaWidget added to this page. Please add a SchemaWidget to provide structured data for this page.",
            severity: "warning",
          };
        }
        return null;
      },
    ],
  ],
});
